import React, { forwardRef, useRef } from "react";
import { useSelector } from "react-redux";
import TapIcon from "../../../services/TapIcon";
import { Link } from "react-router-dom/cjs/react-router-dom";
import { ISC_REQUISITION_URL } from "../../../services/TapApiUrls";
import swal from 'sweetalert';
import { toast } from "react-toastify";
import HttpAPICall from "../../../services/HttpAPICall";
import QuotationAddDocument from "./QuotationAddDocument";

const QuotationDocument = forwardRef((props, ref) => {

    const { quotationDetails, getQuotationDetail }   =   props
    const quotationDocumentModalRef      =   useRef(null)
    const permissions           =   useSelector(state => state.app.acl_info && state.app.acl_info.permissions ? state.app.acl_info.permissions : []);
    const access_token          =   useSelector(state => state.auth.access_token ? state.auth.access_token : "")

    const handleDocumentModal        =   () => {
        quotationDocumentModalRef.current.showModalInit();
    }

    const deleteQuotationDocument    = (doc_id) => {
        swal({
            title: "Delete",
            text: "This action cannot be reversed, Are you sure you want to proceed?",
            icon: "warning",
            dangerMode: true,
            buttons: ["No", "Yes"],
        }).then(willDelete => {
            if (willDelete) {
                HttpAPICall.withAthorization('DELETE', ISC_REQUISITION_URL + '/document_delete/' + doc_id, access_token, {}, {}, (response) => {
                    toast.success(response.data.msg, { position: toast.POSITION.TOP_RIGHT });
                    getQuotationDetail(quotationDetails.transaction_id);
                }).then(() => { });
            }
        });
    }
    return (
        <>
            <div className="tab_content_wrapper">
                <span className="content_heading">Document</span>
                {
                    permissions.includes('scrm_quotation_doc_add') &&
                    <span className="text-end dropdown">
                        <button type="button"
                            onClick={() => handleDocumentModal()}
                            className="btn btn-light">
                            <TapIcon.FontAwesomeIcon className="text-muted" icon={TapIcon.faPlus} />
                        </button>
                    </span>
                }
            </div>
            <table className="table table-bordered bg-white my-2">
                <tbody>
                    {
                        quotationDetails.docs && quotationDetails.docs.length > 0
                            ? quotationDetails.docs.map((d, i) => {
                                return <tr key={i}>
                                    <td scope="col" style={{ width: "5%" }}>{i + 1}</td>
                                    <td scope="col" style={{ width: "65%" }} className="text-capitalize">
                                        {d.name}
                                        {d.number && `(${d.number})`}
                                    </td>
                                    {d.longitude && d.latitue && (
                                        <td scope="col" style={{ width: "6%" }} className="text-center" >
                                            <Link to={`https://www.google.com/maps/search/${d.latitude},${d.longitude}`} target="_blank"><TapIcon.FontAwesomeIcon
                                                icon={TapIcon.faMapMarker} />
                                            </Link>
                                        </td>
                                    )}
                                    <td scope="col" className="text-center" style={{ width: "6%" }} >
                                        <Link to={{ pathname: d.path }} target="_blank"
                                            className={[permissions.includes('scrm_quotation_doc_view') ? '' : 'disabled-link'].join(' ')}
                                            title={permissions.includes('scrm_quotation_doc_view') ? '' : 'You do not have permission to perform this action'}
                                            style={{ "pointerEvents": "all" }}>
                                            <TapIcon.FontAwesomeIcon icon={TapIcon.faEye} />
                                        </Link>
                                    </td>

                                    <td scope="col" style={{ width: "6%" }} className="text-center">
                                        <Link to={{ pathname: d.path }} target='_blank'
                                            className={[permissions.includes('scrm_quotation_doc_download') ? '' : 'disabled-link'].join(' ')}
                                            title={permissions.includes('scrm_quotation_doc_download') ? '' : 'You do not have permission to perform this action'}
                                            style={{ "pointerEvents": "all" }}>
                                            <TapIcon.FontAwesomeIcon icon={TapIcon.faDownload} />
                                        </Link>
                                    </td>
                                    <td className="text-center" style={{ width: "6%" }}>
                                        <Link
                                            className={[permissions.includes('scrm_quotation_doc_delete') ? '' : 'disabled-link'].join(' ')}
                                            style={{ "pointerEvents": "all" }}
                                            onClick={() => { permissions.includes('scrm_quotation_doc_delete') && deleteQuotationDocument(d.id) }}>
                                            <TapIcon.FontAwesomeIcon icon={TapIcon.faTrashAlt}
                                                className="asset_link" /></Link>
                                    </td>
                                </tr>
                            })
                            : <tr><td className='text-center' colSpan="6">No Document Found</td></tr>
                    }
                </tbody>
            </table>
            <QuotationAddDocument ref={quotationDocumentModalRef} quotationData={quotationDetails}
                getQuotationDetail={getQuotationDetail}
            />
        </>
    )

})
export default QuotationDocument 